module.exports = __webpack_public_path__ + "assets/icon_s2p.c5dc74b7.svg";